<template>

    <div>
      <component-loader :progress="90" v-if="showLoader" :unlimitedProgress="true" :activeClose="true" v-on:close="showLoader = false"></component-loader>
        <div class="subtitle">
            <p>
                {{$t('dash.pages.overlay.last')}}<br>
                {{$t(`dash.pages.overlay.select_${['facebook', 'instagram', 'google', 'linkedin'].includes(this.network) ? this.network : 'default'}`)}}
            </p>
        </div>
        <div class="warning" v-if="this.network == 'linkedin'">
          {{$t('dash.pages.linkedin.warning')}}
        </div>

        <div class="search-page">
          <div class="select-all" @click="selectAll">{{$t('dash.pages-sidebar.cta-select-all')}}</div>
          <div class="unselect-all" @click="unselectAll">{{$t('dash.pages-sidebar.cta-unselect-all')}}</div>
          <vs-input
            v-model="pageFilter"
            :class="{'input': true}"
            color="#B20564"
            class="inputx"
            icon-after="true"  icon="search"
            :placeholder="$t('dash.settings.user.label.page_filter')"
          />          
        </div>

        <div class="connected-pages">
            <div class="linked-pages">
                <div class="page" v-for="item in showLinked" :key="item.id" @click="alertUnlink(item)">
                    <div class="page-wrapper">
                        <div class="page-content">
                            <vs-avatar class="page-img" size="33px" :src="item.avatar" alt="page" />
                            <p class="page-name">{{ item.name }}</p>
                            <p class="page-type">{{ item.type }}</p>
                            <div class="checkmark">
                                <i class="material-icons">check</i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr>
            <div class="subtitle">
                <p>
                    {{$t('dash.pages.overlay.unlinked')}}
                </p>
            </div>
            <div class="unlinked-pages">
                <div class="page" v-for="item in showUnlinked" :key="item.id" @click="add(item)">
                    <div class="page-wrapper">
                        <div class="page-content">
                            <vs-avatar class="page-img" size="33px" :src="item.avatar" alt="page" />
                            <p class="page-name">{{ item.name }}</p>
                            <p class="page-type">{{ item.type }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="button-wrapper">
            <vs-button class="page-btn btn-large" @click="validate" vs-type="filled">
                {{$t('dash.pages.overlay.validate')}}
            </vs-button>
        </div>

        <vs-popup :title="dialog.title" :active.sync="dialog.show" class="overlay">
            <p>{{dialog.message}}</p>
        </vs-popup>

        <div class="close-btn" @click="cancel">
            <i class="material-icons">close</i>
        </div>
    </div>

</template>

<script>
  import moment from 'moment'

  import Common from '../../mixins/Common'
  import Pages from '../../mixins/Pages'
  import Notif from '../../mixins/Notif'
  import componentLoader from './../overlay/Loader.vue'
  
  import Lock from '../../../utils/Lock'

  export default {
    name: 'component-pages-overlay',

    props: {
      liked: {
        type: Array,
        required: true
      },
      unliked: {
        type: Array,
        required: true
      },
      isGroup: Boolean,
      network: String,
    },
    
    components: {
      componentLoader
    },

    mixins: [Common, Pages, Notif],

    data() {
      return {
        linked: [],
        unlinked: [],
        dialog: {
          show: false,
          title: 'Add new page',
          message: null
        },
        saved: [],
        pagesToAdd: [],
        pagesToDelete: [],
        showLoader: false,
        pageFilter: ''
      }
    },

    created: function () {
      this.$ga.page('/dash/pages/create')
      this.linked = Array.from(this.liked)
      this.unlinked = Array.from(this.unliked)
      if(this.limitToAdd >= 0)
        this.pagesToAdd = Array.from(this.unliked.slice(0, this.limitToAdd))
      else
        this.pagesToAdd = Array.from(this.unliked)
      
      /*this.$ga.page('/dash/pages/create')
      this.linked = Array.from(this.liked)
      this.unlinked = Array.from(this.unliked)
      this.pagesToAdd = Array.from(this.unliked)*/
    },

    computed: {
      showLinked(){
        let pages = this.linked.filter(l => l.network == this.network && !!l.isGroup == this.isGroup && !this.pagesToDelete.find(p => p.network_id.toString() == l.network_id.toString()) && !(l.story_config && l.story_config.onlyConciergerie && l.story_config.isPersonal)).concat(this.pagesToAdd)
        return pages.filter((l,i) => pages.filter(p => p.network_id.toString() == l.network_id.toString()).length == 1 || (pages.findIndex(p => p.network_id.toString() == l.network_id.toString()) == i))
                    .filter(p => this.checkPageFilter(p))
      },

      showUnlinked(){
        let pages = this.unlinked.filter(u => !this.pagesToAdd.find(p => p.network_id.toString() == u.network_id.toString())).concat(this.pagesToDelete)
        return pages.filter((l,i) => pages.filter(p => p.network_id.toString() == l.network_id.toString()).length == 1 || (pages.findIndex(p => p.network_id.toString() == l.network_id.toString()) == i))
                    .filter(p => this.checkPageFilter(p))
      },

      limitToAdd(){
        let user = JSON.parse(localStorage.user)
        let limit = user && user._premium && user._premium.plan ? Lock.rs_limit[user._premium.plan] : 1
        //limit pages on postday.io & matthieu accounts (prod/dev)
        if(['ae993ea1-a5bf-48d6-b151-507b8a258ebd', 'd2e5ed17-eaf3-4ba0-a2ba-9e1f95757776', 'd12717da-7255-4d0d-a77c-417578e016a8'].includes(JSON.parse(localStorage.user).account)) limit = 5000
        //saabre
        else if(['ae86abdb-a77f-4434-a682-87bc265b0da4'].includes(JSON.parse(localStorage.user).account)) limit = 20
        //wamiz
        else if(['ae86abdb-a77f-4434-a682-87bc265b0da4'].includes(JSON.parse(localStorage.user).account)) limit = 12
        //wmki
        else if(['da502f9e-c999-4896-baed-4e1c4110409a'].includes(JSON.parse(localStorage.user).account)) limit = 70
        //atelier.design & espacil
        else if(['61a66962-65bb-46d0-a671-40e1ab9399ba', 'ce837a3e-8b74-49ce-a515-a628cdb4244d'].includes(JSON.parse(localStorage.user).account)) limit = 60
        let pages = this.liked
        let nbPages = pages.length
        let pagesToAdd = this.unliked
        if(nbPages >= limit) 
          return 0
        else if(nbPages + pagesToAdd.length > limit) 
          return nbPages + pagesToAdd.length - limit
        else  
          return limit - nbPages
      }
    },

    methods: {

      checkPageFilter(page){
        return page.name.toLowerCase().includes(this.pageFilter.toLowerCase())
      },

      selectAll() {
        if(this.pagesToAdd.length < this.limitToAdd){
          this.showUnlinked.map(item => {
            if(!this.liked.find(l => l.network_id.toString() == item.network_id.toString()))
              this.pagesToAdd.push(item)
            this.pagesToDelete = this.pagesToDelete.filter(p => p.network_id.toString() != item.network_id.toString())
          })
        }
        else
          // this.$vs.notify({
          this.notify({
            title: this.$t('dash.notify.limit_page.title'),
            text: this.$t('dash.notify.limit_page.description'),
            color:'success',
            time: 4000,
            id: null
          })
      },

      unselectAll() {
        this.showLinked.map(item => {
          // only new pages
          if(this.unliked.find(u => u.network_id.toString() == item.network_id.toString())){
            this.pagesToAdd = this.pagesToAdd.filter(p => p.network_id.toString() != item.network_id.toString())
          }
        })
      },

      add(item){
        if(this.pagesToAdd.length < this.limitToAdd){
          if(!this.liked.find(l => l.network_id.toString() == item.network_id.toString()))
            this.pagesToAdd.push(item)
          this.pagesToDelete = this.pagesToDelete.filter(p => p.network_id.toString() != item.network_id.toString())
        }
        else
          // this.$vs.notify({
          this.notify({
            title: this.$t('dash.notify.limit_page.title'),
            text: this.$t('dash.notify.limit_page.description'),
            color:'success',
            time: 4000,
            id: null
          })
    },

      remove(item){
        if(!this.unliked.find(u => u.network_id.toString() == item.network_id.toString()))
          this.pagesToDelete.push(item)
        this.pagesToAdd = this.pagesToAdd.filter(p => p.network_id.toString() != item.network_id.toString())
      },

      /**
       * Link element on click
       * @param item
       */
      async link(item) {
        let body = {
          'name': item.name,
          'network': item.network || 'facebook',
          'network_id': item.network_id,
          'avatar': item.avatar
        }
        
        if(['instagram', 'google'].includes(item.network)) body['affected_to'] = item.affected_to || null
        
        if(item.isGroup) body['isGroup'] = true

        if (item.access_token)
          body['token'] = item.access_token

        if(item.network == 'google')
          body['expires_at'] = moment().add(item.expires_at, 'seconds').format()
        else if (item.expires_at)
          body['expires_at'] = item.expires_at
        
        if (item.refresh_token)
          body['refresh_token'] = item.refresh_token

        await this.newPage(body).then(
          res => {
            const { success, page } = res.body

            let messageLog = `${res.url} --- params: ${JSON.stringify(body)} --- response: ${res.bodyText}`
            this.addLog(JSON.parse(localStorage.user), 'add-page', messageLog)

            if (!success || success !== true) {
              this.notify({
                title: this.$t(res.body.error+'.title'),
                text: this.$t(res.body.error+'.body'),
                color:'success',
                time: 4000,
                id: null
              })
              // this.dialog.title = 'Error'
              // if (!res.body) {
              //   this.dialog.message = 'Server not responding…'
              // } else {
              //   this.dialog.message = res.body.statusText
              // }
              // this.dialog.show = true
              return
            }

            let index = this.unlinked.indexOf(item)
            if (index !== -1) {
              this.unlinked.splice(index, 1)
              this.linked.push(page)
            }
          }
        )
      },

      alertUnlink(item){
        if(!this.unliked.find(u => u.network_id.toString() == item.network_id.toString())){
          this.$vs.dialog({
            color: 'primary',
            title: this.$t('dash.pages.delete.title'),
            text: this.$t('dash.pages.delete.description'),
            acceptText: "OK",
            accept: () => {
              this.remove(item)
            }
          })
        }
        else
          this.remove(item)
      },

      /**
       * Unlink element on click
       * @param {Object} item - Object to move unlinked array
       */
      async unlink(item) {

        await this.deletePage(item.id).then(
          res => {
            const { success, deleted } = res.body
            
            let messageLog = `${res.url} --- params: ${JSON.stringify(item)} --- response: ${deleted}`
            this.addLog(JSON.parse(localStorage.user), 'remove-page', messageLog)

            if (!success || success !== true) {
              this.dialog.title = 'Error'
              if (!res.body) {
                this.dialog.message = 'Server not responding…'
              } else {
                this.dialog.message = res.body.statusText
              }
              this.dialog.show = true
              return
            }

            if (deleted) {
              let index = this.linked.indexOf(item)
              if (index !== -1) {
                this.linked.splice(index, 1)
                localStorage.setItem('pages', JSON.stringify(this.linked))
                //this.unlinked.push(item)
              }
            }
          }
        )
      },

      /**
       * Validate pages changes
       */
      async validate() {
        this.showLoader = true
        // await this.pagesToAdd.map(async p => {
        for(let p of this.pagesToAdd) {
          await this.link(p)
        } //)
        // await this.pagesToDelete.map(async p => {
        for(let p of this.pagesToDelete) {
          await this.unlink(p)
        } //)        
        // this.pagesToAdd = []
        // this.pagesToDelete = []
        setTimeout(() => this.$emit('close', this.linked, this.unlinked), 500)
        this.showLoader = false
      },

      /**
       * Cancel pages changes
       */
      cancel() {   
        this.$emit('close', this.liked, this.unliked)
      }
    }
  }
</script>
